<template>
  <div class="dayWrapper">
    <header class="flexRow">
      <h1>Today</h1>
      <new-category class="newCategoryButton" />
      <the-line v-if="isBetaUser && isMobile()" :categories="categories" />
    </header>

    <!-- FIXME - Turn this into a component -->
    <template v-for="category in orderedCategories" v-if="!category.parentId">
      <!-- v-for="(category, key) in categories" v-if="!category.parentId"> -->
      <div
        :class="['flexRow category', category.children && category.showChildren ? 'parent' : '']"
        @click="emitCategoryClick(category.id)"
      >
        <!-- FIXME - Make this static if we're not in edit mode -->
        <!-- FIXME - IF WE ARE NOT EDITING, HIDE CATEGORIES WITH NO BLOCKS? MAKE THIS A TOGGLE -->
        <category-details-block
          :category="category"
          :completed="getCategoryCompleted(category.id, date)"
          :quota="getCategoryQuota(category.id)"
          :directLink="false"
          :showEditTrigger="true"
        />

        <!-- FIXME - AT THE VERY LEAST, MOVE QUOTA TO A FUNCTION AND ERROR CHECK PLEASE -->
        <current-blocks
          class="currentBlocks"
          :blocks="!category.showChildren ? category.totalBlocks : category.blocks"
          :category="category.name"
          :quota="getCategoryQuota(category.id, date, false)"
          :color="category.color"
          :categoryId="category.id"
          :isContinuous="true"
          :customDate="date"
        />
      </div>
      <!-- FIXME - THERE HAS TO BE A BETTER WAY TO DO THIS -->
      <template v-if="category.showChildren">
        <div
          class="flexRow subcategory"
          v-for="childId in Object.keys(category.children || {})"
          @click="emitCategoryClick(childId)"
        >
          <subcategory-details-block :categoryId="childId" :showEditTrigger="true" />
          <current-blocks
            class="currentBlocks"
            :blocks="categories[childId].blocks"
            :category="categories[childId].name"
            :quota="getCategoryQuota(childId, date, false)"
            :color="categories[childId].color"
            :categoryId="childId"
            :isContinuous="true"
            :customDate="date"
          />
        </div>
      </template>
    </template>
  </div>
</template>

<script>
// TODO - Edit category?
// TODO - Different layouts?

import CurrentBlocks from "../components/CurrentBlocks.vue";
import CategoryDetailsBlock from "../components/CategoryDetailsBlock.vue";
import SubcategoryDetailsBlock from "../components/SubcategoryDetailsBlock.vue";
import DaySummary from "../components/DaySummary.vue";
import NewBlock from "../components/NewBlock.vue";
import NewCategory from "../components/NewCategory.vue";
import TheLine from "../components/TheLine.vue";

import db from "../db.js";
import util from "../util.js";
import auth from "../auth.js";
import eventHub from "../eventHub.js";
import categoryUtil from "../categoryUtil.js";

export default {
  name: "today-view",
  mixins: [categoryUtil.getMixin(), util.getMobileMixin()],
  components: {
    "current-blocks": CurrentBlocks,
    "category-details-block": CategoryDetailsBlock,
    "subcategory-details-block": SubcategoryDetailsBlock,
    "day-summary": DaySummary,
    "new-block": NewBlock,
    "new-category": NewCategory,
    TheLine,
  },
  props: ["categories"],
  data() {
    return {
      blocks: {},
      date: util.getCurrentDay(),
    };
  },
  computed: {
    orderedCategories() {
      let ordered = [];
      Object.keys(this.categories).forEach(k => ordered.push(this.categories[k]));
      ordered.sort((a, b) => {
        //FIXME - This should be done elsewhere, please!
        a.orderImportance = a.orderImportance ? a.orderImportance : 0;
        b.orderImportance = b.orderImportance ? b.orderImportance : 0;
        if (a.orderImportance < b.orderImportance) {
          return 1;
        }
        if (a.orderImportance > b.orderImportance) {
          return -1;
        }
        return 0;
      });

      return ordered;
    },
    isBetaUser: () => auth.isBetaUser(),
  },
  methods: {
    emitCategoryClick(categoryId) {
      eventHub.$emit("category-details-block-clicked", { id: categoryId });
    },
  },
};
</script>

<style>
.flexRow.category .action-icon.editIcon,
.flexRow.subcategory .action-icon.editIcon {
  opacity: 0;
}

.flexRow.category:hover .action-icon.editIcon,
.flexRow.subcategory:hover .action-icon.editIcon {
  opacity: 1;
}

.subcategory .blockRow {
  padding: 0.125rem;
  padding-left: 0.75rem;
}

@media (max-width: 600px) {
  .subcategory .blockRow.flexRow {
    padding: 0.125rem;
    padding-left: 0.25rem;
  }
}
</style>

<style scoped>
h1 {
  min-width: 230px;
}

header {
  align-items: flex-end;
  justify-content: space-between;
}

.newCategoryButton {
  margin: 1rem 0;
}

.dayWrapper {
  max-width: 600px;
  margin: auto;
}

.currentBlocks.flexRow {
  max-width: 65%; /* FIXME - This should be something other than percentages */
}

.flexRow.category {
  margin: 0.75rem;
  /*align-items: baseline;*/
}

.flexRow.category.parent {
  margin-bottom: 0;
}

.flexRow.subcategory {
  margin: 0 0.75rem;
}

.editLink {
  font-size: 0.75rem;
  text-decoration: none;
  cursor: pointer;
  color: #ccc;
}

.editLink:hover {
  color: #3498db;
}

@media (max-width: 600px) {
  .flexRow.category {
    margin: 0.25rem;
    flex-direction: column;
    align-items: flex-start;
    align-content: flex-start;
  }

  .currentBlocks.flexRow {
    max-width: none;
  }

  .flexRow.subcategory {
    flex-direction: column;
    align-items: flex-start;
    align-content: flex-start;
  }

  .subcategory .blockRow {
    padding-left: 0.5rem;
  }

  h1 {
    text-align: left;
    margin-left: 0.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// TodayView.vue?744d1ee0